import React, { FC, useState } from "react";
import { Heading } from "@digipost/dds-heading-react";
import styles from "./Oppsummering.module.less";
import Translated from "../infrastructure/translation/Translated";
import { Checkbox } from "@digipost/dds-checkbox-react";
import {
  ButtonGroup,
  PrimaryButton,
  SecondaryButton,
} from "@digipost/dds-buttons-react";
import { useLanguage } from "@digipost/translate";
import { getTermsUrl } from "../infrastructure/translation/translatedUrls";
import { Banner } from "@digipost/dds-banner-react";
import { InputWrapperWithErrorMessage } from "../InputWrapperWithErrorMessage/InputWrapperWithErrorMessage";
import { OppsummeringBody, SummaryPoint } from "./OppsummeringBody";
import { TranslationKey } from "../infrastructure/translation/translator";

const Oppsummering: FC<{
  goBack: () => void;
  submitAction: () => void;
  submitTextKey: TranslationKey;
  summaryPoints: SummaryPoint[];
  showTermsCheckbox?: boolean;
  isSubmitting?: boolean;
}> = ({
  goBack,
  submitAction,
  submitTextKey,
  summaryPoints,
  showTermsCheckbox,
  isSubmitting,
}): React.ReactElement => {
  const { language } = useLanguage();

  const [acceptedTerms, setAcceptedTerms] = useState<boolean>(false);
  const [showTermsWarning, setShowTermsWarning] = useState<boolean>(false);
  const [showSubmitError, setShowSubmitError] = useState<boolean>(false);

  const onSubmitHandler = () => {
    if (showTermsCheckbox) {
      setShowSubmitError(false);
      if (!acceptedTerms) {
        setShowTermsWarning(true);
        return;
      }
    }
    submitAction();
  };

  return (
    <section>
      {showSubmitError && (
        <Banner variant={"warning"} role={"alert"}>
          <p>
            <Translated textKey={"generic.error"} />
          </p>
        </Banner>
      )}
      <Heading level={1} size={"large"}>
        <Translated textKey={"summary.header"} />
      </Heading>
      <OppsummeringBody summaryPoints={summaryPoints} />
      <div>
        {showTermsCheckbox && (
          <InputWrapperWithErrorMessage
            customClassName={styles.acceptTermsContainer}
            showError={showTermsWarning}
            errorTextKey="summary.accept_terms_warning"
            InputComponent={
              <Checkbox
                name={"acceptTerms"}
                value={"acceptTerms"}
                checked={acceptedTerms}
                onChange={(e) => {
                  setAcceptedTerms(e.target.checked);
                  setShowTermsWarning(false);
                }}
              >
                <Translated
                  allowHtml
                  textKey={"summary.accept_terms"}
                  params={{ href: getTermsUrl(language) }}
                />
              </Checkbox>
            }
          />
        )}
        <ButtonGroup>
          <SecondaryButton
            type="button"
            onClick={goBack}
            disabled={isSubmitting}
          >
            <Translated textKey={"generic.back"} />
          </SecondaryButton>
          <PrimaryButton onClick={onSubmitHandler} loading={isSubmitting}>
            <Translated textKey={submitTextKey} />
          </PrimaryButton>
        </ButtonGroup>
      </div>
    </section>
  );
};

export default Oppsummering;
